import {Component} from "@angular/core";

/**
 * Created by Benoit Valkenberg on 16-12-17.
 */
@Component({
    styleUrls: ['./leasing.scss'],
    templateUrl: './leasing.html'
})
export class LeasingPageComponent {

}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/leasing.ts